import {Component, inject, OnInit} from '@angular/core';
import {GridPageComponent, FilterConfig} from "../../common/grid-page.component";
import {ColorClass, StorageUnitByBinGridViewDto, StorageUnitStatus} from "@services";
import EnumUtils from "../../../shared/enum-utils";
import {CommonModule} from "@angular/common";
import {
    DxDataGridModule,
    DxFormModule,
    DxTemplateModule,
    DxTabsModule
} from "devextreme-angular";
import {FilterPanelComponent} from "../../../components/library/filter-panel/filter-panel.component";
import {ActivatedRoute} from "@angular/router";
import {CapitalCasePipe} from "../../../pipes/capital-case.pipe";
import {SLAScoreComponent} from "./sla-score/sla-score.component";

@Component({
    selector: 'app-storage-units-by-bin',
    standalone: true,
    imports: [
        CommonModule,
        DxDataGridModule,
        DxFormModule,
        DxTemplateModule,
        FilterPanelComponent,
        CapitalCasePipe,
        DxTabsModule,
        SLAScoreComponent
    ],
    templateUrl: './storage-units-by-bin.component.html',
    styles: [
        `.grid {
            height: calc(100vh - 150px);
        }`
    ]
})
export class StorageUnitsByBinComponent extends GridPageComponent<StorageUnitByBinGridViewDto> implements OnInit {
    private activeRoute = inject(ActivatedRoute);

    dataSource: any;
    pageTitle: string = 'Storage Units';
    storageTypeCode?: string;
    slaTitle: string = 'SLA Score';
    isLT22: boolean = false;
    storageKey: string = 'storage-units-by-bin-grid-state';

    tabs = [
        { text: 'My Score', id: 0 },
        { text: 'Data', id: 1 }
    ];
    selectedTab = this.tabs[0];

    constructor() {
        super();
        this.init(StorageUnitByBinGridViewDto);
    }

    ngOnInit() {
        this.activeRoute.data.subscribe(data => {
            const storageTypeCode = data['binType'];
            const title = data['title'];
            if (storageTypeCode) {
                this.storageTypeCode = storageTypeCode;
                this.isLT22 = storageTypeCode === 'LT22';
                this.storageKey = this.isLT22 ? 'storage-units-by-bin-lt22-grid-state' : 'storage-units-by-bin-grid-state';
                this.slaTitle = title ? `${title} Score` : `SLA Score`;
                this.dataSource = this.dataSources.storageUnitsByBin(storageTypeCode);
                this.exportName = `Storage_Units_${storageTypeCode}`;
                this.pageTitle = title || `Storage Units ${storageTypeCode}`;
            }
        });
    }

    onTabClick(e: any) {
        this.selectedTab = e.itemData;
    }

    statusOptions = EnumUtils.getEnumOptions(StorageUnitStatus);

    protected override filterConfig: FilterConfig[] = [
        {field: 'materialNumber', op: 'contains'},
        {field: 'storageUnitNumber', op: 'contains'},
        {field: 'binNumber', op: 'contains'},
        {field: 'materialDescription', op: 'contains'},
        {field: 'batch', op: 'contains'},
        {field: 'stockCategory', op: 'contains'},
        {field: 'totalQuantityWmUoM', op: '>='},
        {field: 'wmUnit', op: 'contains'},
        {field: 'duration', op: '>='},
        {field: 'grDate', op: '>='},
        {field: 'lastChangedBy', op: 'contains'},
        {field: 'sledBbd', op: '>='},
        {field: 'numberOfQuants', op: '>='},
        {field: 'transferOrderNo', op: 'contains'},
        {field: 'lastMovement', op: '>='},
        {field: 'lastStockPlacement', op: '>='},
        {field: 'slaStatus', op: 'contains'},
        {field: 'status', op: '='},
        {field: 'duplicate', op: '='},
        {field: 'dateCompleted', op: '>='},
    ];

    protected getStatusBadgeClass(status: StorageUnitStatus): string {
        return EnumUtils.getStorageUnitStatusBadgeClass(status);
    }

    protected getColorBadgeClass(color: ColorClass): string {
        return EnumUtils.getColorBadgeClass(color);
    }
}
